import { useState } from 'react';

import { ReactComponent as CookieIcon } from 'assets/images/misc/cookie.svg';

import CookieConsent from 'components/CookieConsent';
import IntlMessages from 'components/util/IntlMessages';

import type { TCookiesType } from 'types/cookies';

const CookieBanner = () => {
    const [policyTypeToShow, setPolicyTypeToShow] = useState<TCookiesType | null>(null);

    return (
        <div className="cookie-banner-content">
            <div className="cookie-banner-title">
                <CookieIcon />
                <span>
                    <IntlMessages id="label.cookies.title" />
                </span>
            </div>
            <div className="cookie-banner-text">
                <IntlMessages id="label.cookies.content" whitespaceEnd />
                <span className="link" onClick={() => setPolicyTypeToShow('privacy-policy')}>
                    <IntlMessages id="label.here" />
                </span>
                .
            </div>
            {!!policyTypeToShow && (
                <CookieConsent type={policyTypeToShow} close={() => setPolicyTypeToShow(null)} showPolicyHandler={setPolicyTypeToShow} />
            )}
        </div>
    );
};

export default CookieBanner;
